import {
  applyFacingFromIntent as applyFacingEngine,
  setDesiredToward as setDesiredEngine,
} from "../../../sim/motion-steering";
import type { SimEntity } from "./types";
import { C } from "./shared";

function facingKnobs() {
  return {
    facingFlipEps: C.crowd.facingFlipEps,
    facingHoldSec: C.crowd.facingHoldSec,
  };
}

function arriveKnobs() {
  return {
    arriveStop: C.crowd.arriveStop,
    arriveExitMul:
      Number(
        (C.crowd as { arriveExitMul?: number }).arriveExitMul,
      ) || 1.5,
  };
}

export function applyFacingFromIntent(
  e: SimEntity,
  intentVx: number,
  time: number,
): void {
  applyFacingEngine(e, intentVx, time, facingKnobs());
}

export function setDesiredToward(
  e: SimEntity,
  tx: number,
  ty: number,
  speedMul: number,
  time: number,
): void {
  setDesiredEngine(
    e,
    tx,
    ty,
    speedMul,
    time,
    arriveKnobs(),
    facingKnobs(),
  );
}
